import { ReactToChatMessageDefinition } from "@super-real/types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const reactToChatMessageCallable = getCallable(
  ReactToChatMessageDefinition
);
